import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { Gateway } from 'types/gateway';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

export function useGateway(
  id: string | null | undefined,
  { enabled, ...options }: UseQueryOptions<Gateway, APIError> = {}
) {
  const { applicationID, client } = useAPI();

  return useAuthenticatedQuery(
    ['gateway', id, applicationID],
    async () => {
      if (!id) {
        return Promise.reject(new Error('No gateway ID provided.'));
      }

      const { data } = await client.get<Gateway>(
        `/apps/${applicationID}/gateways/${id}`
      );

      return data;
    },
    {
      ...options,
      enabled: enabled !== undefined ? enabled && Boolean(id) : Boolean(id),
    }
  );
}
